import { BareActionContext } from 'vuex-typex'
import { CommentState } from '../state'
import { RootState } from '../..'
import { CommentService } from '../../../service/CommentService'
import TYPES from '../../../config/Types'
import { DependencyContainer } from '../../../config/DependencyContainer'
import { Meta } from '../../../model/meta'
import commentStore from '../comment-store'
import { IComment } from '../../../model/comment'
import { MetaService } from '../../../service/MetaService'

const commentService = DependencyContainer.getContainer().get<CommentService>(TYPES.CommentService)

const commentUtils = {
    get commentService () { return commentService },
}

export default commentUtils
